
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DateHelper } from '../../../shared/helpers/date.helper';
import { ApiSettings } from '../../../shared/models/api/api-settings';
import { LogService } from '../../../shared/services/log.service';
import { FileResultModel } from 'src/app/shared/models/fileresult.model';
import { ExportOdgRequest } from '../../models/api/requests/export-odg.apirequest';
import { FileHelper } from 'src/app/shared/helpers/file.helper';
import { OdgPrestationsConvivesRequest } from '../../models/api/requests/odg-prestations-convives.apirequest';
import { OdgPrestationsConvivesResponse } from '../../models/api/responses/odg-prestations-convives.apiresponse';

@Injectable()
export class OdgReportingApiService {
  private _controllerUrl: string = 'odg';

  constructor(private apiSettings: ApiSettings, private http: HttpClient, private logService: LogService) { }

  exportRecapitulatifDesPlats(request: ExportOdgRequest): Observable<FileResultModel> {
    let httpParams = new HttpParams();

    if (request.cuisineCentraleId) {
      httpParams = httpParams.set('cuisineCentraleId', String(request.cuisineCentraleId));
    }
    if (request.grandCompteId) {
      httpParams = httpParams.set('grandCompteId', String(request.grandCompteId));
    }
    if (request.contratId) {
      httpParams = httpParams.set('contratId', String(request.contratId));
    }
    if (request.dateDebut) {
      httpParams = httpParams.set('dateDebut', DateHelper.toISODateString(request.dateDebut));
    }
    if (request.dateFin) {
      httpParams = httpParams.set('dateFin', DateHelper.toISODateString(request.dateFin));
    }
    if(request.odgPrestationIds){
      for (const prestationsId of request.odgPrestationIds) {
        httpParams = httpParams.append('odgPrestationIds', String(prestationsId));
      }
    }
    if(request.odgConviveIds){
      for (const convivesId of request.odgConviveIds) {
        httpParams = httpParams.append('odgConviveIds', String(convivesId));
      }
    }

    const url = `${this.apiSettings.apiUrl}/${this._controllerUrl}/ExportRecapPlats`;
    return FileHelper.getFile(this.http, url, httpParams);
  }

  exportSyntheseDetailleePlats(request: ExportOdgRequest): Observable<FileResultModel> {
    let httpParams = new HttpParams();

    if (request.cuisineCentraleId) {
      httpParams = httpParams.set('cuisineCentraleId', String(request.cuisineCentraleId));
    }
    if (request.grandCompteId) {
      httpParams = httpParams.set('grandCompteId', String(request.grandCompteId));
    }
    if (request.contratId) {
      httpParams = httpParams.set('contratId', String(request.contratId));
    }
    if (request.dateDebut) {
      httpParams = httpParams.set('dateDebut', DateHelper.toISODateString(request.dateDebut));
    }
    if (request.dateFin) {
      httpParams = httpParams.set('dateFin', DateHelper.toISODateString(request.dateFin));
    }
    if(request.odgPrestationIds){
      for (const prestationsId of request.odgPrestationIds) {
        httpParams = httpParams.append('odgPrestationIds', String(prestationsId));
      }
    }
    if(request.odgConviveIds){
      for (const convivesId of request.odgConviveIds) {
        httpParams = httpParams.append('odgConviveIds', String(convivesId));
      }
    }

    const url = `${this.apiSettings.apiUrl}/${this._controllerUrl}/ExportSyntheseDetailleePlats`;
    return FileHelper.getFile(this.http, url, httpParams);
  }

  exportSyntheseObservations(request: ExportOdgRequest): Observable<FileResultModel> {
    let httpParams = new HttpParams();

    if (request.cuisineCentraleId) {
      httpParams = httpParams.set('cuisineCentraleId', String(request.cuisineCentraleId));
    }
    if (request.grandCompteId) {
      httpParams = httpParams.set('grandCompteId', String(request.grandCompteId));
    }
    if (request.contratId) {
      httpParams = httpParams.set('contratId', String(request.contratId));
    }
    if (request.dateDebut) {
      httpParams = httpParams.set('dateDebut', DateHelper.toISODateString(request.dateDebut));
    }
    if (request.dateFin) {
      httpParams = httpParams.set('dateFin', DateHelper.toISODateString(request.dateFin));
    }
    if(request.odgPrestationIds){
      for (const prestationsId of request.odgPrestationIds) {
        httpParams = httpParams.append('odgPrestationIds', String(prestationsId));
      }
    }
    if(request.odgConviveIds){
      for (const convivesId of request.odgConviveIds) {
        httpParams = httpParams.append('odgConviveIds', String(convivesId));
      }
    }

    const url = `${this.apiSettings.apiUrl}/${this._controllerUrl}/ExportSyntheseObservations`;
    return FileHelper.getFile(this.http, url, httpParams);
  }


  exportSyntheseGlobale(request: ExportOdgRequest): Observable<FileResultModel> {
    let httpParams = new HttpParams();

    if (request.cuisineCentraleId) {
      httpParams = httpParams.set('cuisineCentraleId', String(request.cuisineCentraleId));
    }
    if (request.grandCompteId) {
      httpParams = httpParams.set('grandCompteId', String(request.grandCompteId));
    }
    if (request.contratId) {
      httpParams = httpParams.set('contratId', String(request.contratId));
    }
    if (request.dateDebut) {
      httpParams = httpParams.set('dateDebut', DateHelper.toISODateString(request.dateDebut));
    }
    if (request.dateFin) {
      httpParams = httpParams.set('dateFin', DateHelper.toISODateString(request.dateFin));
    }
    if(request.odgPrestationIds){
      for (const prestationsId of request.odgPrestationIds) {
        httpParams = httpParams.append('odgPrestationIds', String(prestationsId));
      }
    }
    if(request.odgConviveIds){
      for (const convivesId of request.odgConviveIds) {
        httpParams = httpParams.append('odgConviveIds', String(convivesId));
      }
    }

    const url = `${this.apiSettings.apiUrl}/${this._controllerUrl}/ExportSyntheseGlobale`;
    return FileHelper.getFile(this.http, url, httpParams);
  }

  getPrestationsConvives(request: OdgPrestationsConvivesRequest): Observable<OdgPrestationsConvivesResponse> {
    let httpParams = new HttpParams();

    if (request.cuisineCentraleId) {
      httpParams = httpParams.set('cuisineCentraleId', String(request.cuisineCentraleId));
    }
    if (request.grandCompteId) {
      httpParams = httpParams.set('grandCompteId', String(request.grandCompteId));
    }
    if (request.contratId) {
      httpParams = httpParams.set('contratId', String(request.contratId));
    }
    if (request.dateDebut) {
      httpParams = httpParams.set('dateDebut', DateHelper.toISODateString(request.dateDebut));
    }
    if (request.dateFin) {
      httpParams = httpParams.set('dateFin', DateHelper.toISODateString(request.dateFin));
    }

    const url = `${this.apiSettings.apiUrl}/${this._controllerUrl}/prestations-convives`;

    return this.http.get<OdgPrestationsConvivesResponse>(url, { params: httpParams });
  }

}
